import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormikContext } from 'formik'

import { selectBackError, selectIsLoading } from '@src/store/ducks/auth/selectors'
import { FieldFormik } from '@src/components/FieldFormik/FieldFormik'
import style from '@src/pages/ActivationCard/ActivationCard.module.scss'
import { Button } from '@src/components/Button/Button'
import { registerCard } from '@src/store/ducks/auth/thunks'
import { AppDispatch } from '@src/store/store'

export const ActivationCardForm = () => {
  const dispatch = useDispatch<AppDispatch>()
  const backError = useSelector(selectBackError)
  const isLoading = useSelector(selectIsLoading)
  const { values } = useFormikContext<any>()

  const keyDownHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.code === 'NumpadEnter' || event.code === 'Enter') {
      event.preventDefault()
      dispatch(registerCard(values.cardNumber))
    }
  }

  return (
    <div className={style.activationCardForm}>
      <div>
        <FieldFormik
          label="Введите номер приобретенной карты"
          name="cardNumber"
          placeholder="Номер карты лояльности"
          mask="0000000000000000000"
          styleError={style.customError}
          onKeyPressBtn={keyDownHandler}
        />
      </div>
      {backError && String(backError) && (
      <div className={style.error}>
        *
        {backError}
      </div>
      )}

      <div className={style.btnBlock}>
        <Button
          loading={isLoading}
          htmlType="button"
          type="secondary"
          disabled={values.cardNumber.length < 7}
          className={style.btnSize}
          onClickFunc={() => dispatch(registerCard(values.cardNumber))}
        >
          Активировать
        </Button>
      </div>
    </div>
  )
}
